import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Container from 'react-bootstrap/Container';
import CardColumns from 'react-bootstrap/CardColumns';
import Card from 'react-bootstrap/Card';
import Media from 'react-bootstrap/Media';
import Image from 'react-bootstrap/Image';
import Figure from 'react-bootstrap/Figure';
import galaShowPicture from '../../assets/gala_show.jpg';
import PlaidladsPortrait from '../../assets/plaidlads.jpg';
import classnames from 'classnames';


function Locations() {
  return <div>
    <div class="embed-responsive embed-responsive-16by9">
      <iframe className="embed-responsive-item" src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d2858.947855923851!2d-76.49877528448351!3d44.22873192910579!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e2!4m5!1s0x4cd2ab040df43553%3A0x13e4219bdbf13b60!2sJohn%20Deutsch%20University%20Centre%2C%20University%20Avenue%2C%20Kingston%2C%20ON!3m2!1d44.2284858!2d-76.4946703!4m5!1s0x4cd2ab05e68f8ef1%3A0x9f8794d0fddb7a2f!2sKingston%20Collegiate%20and%20Vocational%20Institute%2C%20Frontenac%20Street%2C%20Kingston%2C%20ON!3m2!1d44.2291573!2d-76.49803!5e0!3m2!1sen!2sca!4v1568012696737!5m2!1sen!2sca" allowfullscreen=""></iframe>
    </div>
    <p className="mt-3 mb-0 order-md- font-weight-bold">KCVI Auditorium</p>
    <p>235 Frontenac Street</p>
    <p>Enter through the main doors and follow signs upstairs. (Only a 6-minute walk from the Main Gym.)</p>
  </div>
}

function PerformersSection(props){
  return <section className="m-0 pt-5">
    <Container>
      <h2 className="display-2 text-left mb-3 mb-lg-5">Performers</h2>
      {
        props.performers.map(({name, bio, portrait}, idx) => {
          const even = idx % 2 === 0;
          return <Row className="py-3">
            <Col md={4} classnames={classnames({'order-md-last': even})}>
              <Figure className="w-30 my-3 my-lg-0">
                <Figure.Image
                  thumbnail
                  src={portrait.src}
                />
                <Figure.Caption dangerouslySetInnerHTML={{__html: portrait.caption}}>
                </Figure.Caption>
              </Figure>
            </Col>
            <Col md={8} className={classnames({'order-md-first': even, 'text-lg-right': even}, 'd-flex', 'flex-column', 'justify-content-center')}>
              <h2 className="display-5 text-primary">{name}</h2>
              <p dangerouslySetInnerHTML={{__html: bio}}></p>
            </Col>
          </Row>
        })
      }
    </Container>
  </section>
}

function GalaShowSection() {
  return <section className="m-0 pt-5" id="top">
    <Container >
      <h2 className="display-2 text-left mb-5">Saturday Night Gala Show</h2>
      <p className="my-3">This year’s show brings together award-winning performers from across North America – Guelph, Toronto, Montreal, Ohio, Colorado – for a family-friendly show that will WOW the socks right off you! Our headliners this year are comedy juggling duo The Plaid Lads made up of 49% Sam Malcolm, 49% Tony Steinbach, and 2% plaid. Individually they are award-winning street performers and side-splitting comedians. Together, in their matching plaid shorts, they are best friends. With their combined off-the-cuff comedy and juggling mastery, The Plaid Lads are taking over the Limestone City Juggling Festival Gala Show as our Master(s) of Ceremonies and headlining act.</p>
      <p className="my-3">7:30 – 9 pm on Saturday, October 26, 2019 in the Auditorium of Kingston Collegiate and Vocational Institute (KCVI) 235 Frontenac Street. Enter via the Frontenac Street main doors.</p>
      <p className="my-3">Tickets are $15 for adults (adult tickets include two free youth tickets), $10 for students, and $5 for additional youth (under 18). Tickets are available cash only at the festival and at the door.</p>
      <Row>
        <Col md="6" className="p-3">
          <Image src={PlaidladsPortrait} rounded fluid />
        </Col>
        <Col md="6" className="p-3">
          <Locations />
        </Col>
      </Row>
    </Container>
  </section>
}

export default function GalaShow(props) {
  return <div className="bg-light">
    <GalaShowSection /> 
    <PerformersSection { ...props }/> 
  </div>
}
